module.exports = __webpack_public_path__ + "img/19a)NH Hotel.jpg";